import "./BiomarkersBasicDetailsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect} from "react";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import Grid from "@mui/material/Grid";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import {ImageConfig} from "../../../../constants";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import CommonService from "../../../../shared/services/common.service";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import FormikSelectDropdownComponent
    from "../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import commonService from "../../../../shared/services/common.service";

interface BiomarkersBasicDetailsAddComponentProps {
    next: Function;
    cancel: Function;
    biomarkerId?: number;
    biomarkerDetails?: any;
}

const BiomarkersBasicDetailsValidationSchema = Yup.object({
    name: Yup.string().required('Required'),
    // code: Yup.string().required('Required'),
    reportFormat: Yup.string().required('Required'),
    sampleType: Yup.string().required('Required'),
    sampleCollectionDeviceName: Yup.string().required('Required'),
    // description: Yup.string().nullable(),
});

interface BiomarkerBasicDetailsFormSchema {
    name: string;
    // code: string;
    reportFormat: string;
    sampleType: string;
    sampleCollectionDeviceName: string;
    // description: string;
}

const biomarkerBasicDetailsFormInitialValues: BiomarkerBasicDetailsFormSchema = {
    name: '',
    // code: '',
    reportFormat: '',
    sampleType: '',
    sampleCollectionDeviceName: '',
    // description: '',
};


const BiomarkersBasicDetailsAddComponent = (props: BiomarkersBasicDetailsAddComponentProps) => {
    const {
        next,
        cancel,
        biomarkerId,
        biomarkerDetails
    } = props;
    const {
        // sampleTypesList,
        // equipmentTypeList,
        sampleTypeWithCollectionDevices,
        reportTypeList
    } = useSelector((state: IRootReducerState) => state.staticData);
    const [biomarkerBasicDetailsInitialValues, setBiomarkerBasicDetailsInitialValues] = React.useState<any>(biomarkerBasicDetailsFormInitialValues);
    const formikRef: any = React.useRef();

    const onSubmit = useCallback((values: any, {
        setSubmitting,
        setErrors,
    }: FormikHelpers<any>) => {
        if (!biomarkerId) {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to continue adding this biomarker?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Continue",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            }).then(() => {
                CommonService._biomarker.addBiomarker(values)
                    .then((response: IAPIResponseType<any>) => {
                        setSubmitting(false);
                        next(response.data.id, response.data);
                    })
                    .catch((error: any) => {
                        CommonService.handleErrors(setErrors, error);
                        setSubmitting(false);
                    });
            }).catch(() => {
                setSubmitting(false);
            })
        } else {
            if (formikRef?.current?.dirty) {
                CommonService._biomarker.updateBiomarker(values, biomarkerId)
                    .then((response: IAPIResponseType<any>) => {
                        setSubmitting(false);
                        next(biomarkerId, response.data);
                    })
                    .catch((error: any) => {
                        CommonService.handleErrors(setErrors, error);
                        setSubmitting(false);
                    });
            } else {
                next(biomarkerId, biomarkerDetails);
                setSubmitting(false);
            }
        }
    }, [biomarkerId, next, biomarkerDetails]);


    useEffect(() => {
        if (biomarkerDetails) {
            setBiomarkerBasicDetailsInitialValues(biomarkerDetails);
        }
    }, [biomarkerDetails]);

    return (
        <div className={'biomarkers-basic-details-add-component screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Basic Details'}
                tooltipData={"Ensure that the name of the Biomarker is unique."}
            />
            <div className="t-form">
                <Formik
                    validationSchema={BiomarkersBasicDetailsValidationSchema}
                    initialValues={biomarkerBasicDetailsInitialValues}
                    validateOnChange={true}
                    innerRef={formikRef}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={onSubmit}
                >
                    {({isSubmitting, values, setFieldError, isValid, errors, setFieldValue, validateForm}) => {
                        return (
                            // eslint-disable-next-line no-script-url
                            <Form noValidate={true} action={'javascript:void'}
                                  className={"biomarker-basic-details-add-holder"}>
                                <div className={"t-form-controls-wrapper"}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            {/*<Field name={'code'}>*/}
                                            {/*    {*/}
                                            {/*        (field: FieldProps) => (*/}
                                            {/*            <FormikInputComponent*/}
                                            {/*                label={'Biomarker Code'}*/}
                                            {/*                fullWidth={true}*/}
                                            {/*                placeholder={'Enter Biomarker Code'}*/}
                                            {/*                type={"text"}*/}
                                            {/*                maxLength={4}*/}
                                            {/*                readOnly={!!biomarkerId}*/}
                                            {/*                required={true}*/}
                                            {/*                formikField={field}*/}
                                            {/*            />*/}
                                            {/*        )}*/}
                                            {/*</Field>*/}
                                            <Field name={'name'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Biomarker Name'}
                                                            fullWidth={true}
                                                            placeholder={'Enter Biomarker Name'}
                                                            type={"text"}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'reportFormat'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Report Type'}
                                                            options={reportTypeList}
                                                            placeholder={'Select Report Type'}
                                                            valueKey={'code'}
                                                            readOnly={!!biomarkerId}
                                                            required={true}
                                                            getOptionLabel={(option) => (option.title) || ''}
                                                            formikField={field}
                                                        />
                                                    )}
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'sampleType'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Sample Type'}
                                                            options={sampleTypeWithCollectionDevices}
                                                            placeholder={'Select Sample Type'}
                                                            valueKey={'sampleType'}
                                                            required={true}
                                                            getOptionLabel={(option) => (commonService.capitalizeFirstLetter(option.sampleType)) || ''}
                                                            formikField={field}
                                                            onUpdate={(value: any) => {
                                                                setFieldValue('sampleCollectionDeviceName', '');
                                                            }
                                                            }
                                                        />
                                                    )}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <Field name={'sampleCollectionDeviceName'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikSelectDropdownComponent
                                                            label={'Sample Collection Device Name'}
                                                            placeholder={'Select Sample Collection Device Name'}
                                                            valueKey={'code'}
                                                            required={true}
                                                            getOptionLabel={(option) => (commonService.capitalizeFirstLetterOfEachWord(option.title)) || ''}
                                                            formikField={field}
                                                            options={commonService.extractCollectionDevicesFromSampleType(values?.sampleType, sampleTypeWithCollectionDevices)}
                                                        />
                                                    )}
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    {/*<Grid container spacing={2}>*/}
                                    {/*    <Grid item xs={12} sm={12} md={12} xl={12}>*/}
                                    {/*        <Field name={'description'}>*/}
                                    {/*            {*/}
                                    {/*                (field: FieldProps) => (*/}
                                    {/*                    <FormikInputComponent*/}
                                    {/*                        label={'Description (if any)'}*/}
                                    {/*                        fullWidth={true}*/}
                                    {/*                        placeholder={'Enter Description'}*/}
                                    {/*                        type={"text"}*/}
                                    {/*                        multiline={true}*/}
                                    {/*                        rows={3}*/}
                                    {/*                        required={false}*/}
                                    {/*                        formikField={field}*/}
                                    {/*                    />*/}
                                    {/*                )}*/}
                                    {/*        </Field>*/}
                                    {/*    </Grid>*/}
                                    {/*</Grid>*/}
                                </div>
                                <div className="form-action-section">
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        disabled={isSubmitting}
                                        handleClick={cancel}
                                    >
                                        Cancel
                                    </ButtonComponent>
                                    <ButtonComponent
                                        type="submit"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={true}
                                        disabled={!isValid}
                                        isLoading={isSubmitting}
                                    >
                                        Proceed
                                    </ButtonComponent>
                                </div>
                            </Form>
                        )
                    }
                    }
                </Formik>
            </div>

        </div>
    );

};

export default BiomarkersBasicDetailsAddComponent;
